/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { useEffect, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { AnnotationLayer } from 'components/annotationLayer'
import { browserCheck } from '@ta-interaktiv/browsercheck'
import { WuhanAnnotationComponent } from 'components/wuhanAnnotationComponent'
import { Summary } from 'components/summary'
import { scaleLinear } from 'd3-scale'
import deskHeader from 'images/worldmap_desktop.svg'
// TODO Set the correct article ID here
const isMobile = browserCheck.isMobile

export function AppComponent() {
  const [annotationData, setAnnotationData] = useState()
  const [countryList, setCountryList] = useState()
  const [summed, setSummed] = useState()

  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard/countries-worldmap.json?a='+Math.random()
    )
      .then(response => {
        return response.json()
      })
      .then(data => {
        setAnnotationData(data)
        const countryL = []
        const others = []
        const sum = {
          cases: 0,
          death: 0,
          countries: 0,
          updated: new Date()
        }
        data.forEach((c, i) => {
          sum.cases += +c.cases
          sum.death += +c.death
          sum.countries += 1
        })
        const otherEl = {
          country: 'Others',
          de: 'Rest der Welt',
          de_mobile: 'Rest der Welt',
          cases: 0,
          death: 0
        }
        others.forEach(o => {
          otherEl.cases += o.cases
          otherEl.death += o.death
        })
        countryL.push(otherEl)
        setSummed(sum)
      })
  }, [])
  const color = scaleLinear()
    .range(['#F0F0F2', '#c8c8d1', '#9698a8', '#FFE462', '#D07800', '#E30609'])
    .domain([0, 1000, 5000, 10000, 100000, 1000000])

  const height = scaleLinear()
    .range([0, 100])
    .domain([0, 10000000])
  return (
    <div className='index'>
      <ThemeSwitch />
      {summed !== undefined && (
        <Summary
          cases={summed.cases}
          death={summed.death}
          countries={summed.countries}
        />
      )}

      <div className='ui vertical very fitted segment'>
        {annotationData && (
          <div className='annotations'>
            <AnnotationLayer
              imageSrc={deskHeader}
              annotations={annotationData}
              AnnotationComponent={WuhanAnnotationComponent}
              id='wuhan_map'
              customLinePadding={2}
              customLineHeight={10}
              marker={['none', 'none']}
              debug={location.origin.includes('localhost')}
            />
          </div>
        )}
        <div className='swipeContainer'>
          {' '}
          {isMobile && (
            <img className='swipe' src={require('images/swipe-01.svg')} />
          )}
        </div>
      </div>
    </div>
  )
}
